import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FreePlanNotice } from './FreePlanNotice';

export function LandingCta({ onCtaClick }: { onCtaClick: () => void }) {
    const { t } = useTranslation();
    return (
        <section id="get-started" className="landing-section landing-cta" aria-labelledby="cta-title">
            <div className="landing-container landing-cta-content">
                <div className="landing-section-heading landing-centered">
                    <p className="landing-eyebrow">{t('cta.freeBadge')}</p>
                    <h2 id="cta-title">{t('cta.title')}</h2>
                    <p>{t('cta.desc')}</p>
                    <button className="landing-button landing-button-light" onClick={onCtaClick}>{t('cta.button')}<ArrowRight size={18} aria-hidden="true" /></button>
                    <FreePlanNotice className="landing-free-plan-notice" />
                </div>
            </div>
        </section>
    );
}
